export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId } = opts;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          droppable: false, 
          icon: '<i class="wb webconnect-chat-dots"></i>',
          traits: [ {
              type: 'text',
              label: 'Key',
              name: 'item-storagekey',
              value: 'browserStorage',
              placeholder: 'eg. browserStorage',
            },],
          script: function () {
            const root = this;
            const toggleBtn = root.querySelector('.chatbox-toggle');
            const wrapper = root.querySelector('.chatbox-message-wrapper');
            const closeBtn = root.querySelector('.chatbox-message-close');

            if (toggleBtn && wrapper) {
              toggleBtn.addEventListener('click', () => {
                wrapper.classList.toggle('show');
              });
            }

            if (closeBtn && wrapper) {
              closeBtn.addEventListener('click', () => {
                wrapper.classList.remove('show');
              });
            }

             this.on('change:item-storagekey', (model, value) => {
    this.setAttributes({
      'item-storagekey': value
    });
  });

          },
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        // this.listenTo(model, 'change:finderUuid', this.updateScript);
      },
    }),
  });
};
